var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-4 text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — Xtreme Admin by "),_c('a',{attrs:{"href":"https://www.wrappixel.com/"}},[_vm._v("wrappixel.com")])])
}
var staticRenderFns = []

export { render, staticRenderFns }